import React, { useEffect } from 'react'
import Playground from './components/quick-game/Playground'
import { FullScreen, useFullScreenHandle } from "react-full-screen";

const QuickGamePage = (props) => {
    const playerList=props.playerList;


    return (
 

            <Playground playerList={playerList} />

      
    )
}

export default QuickGamePage
